export default "__VITE_ASSET__CG$NmYXU__"